import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Product } from "../../interfaces/productInterface";

import sample from "../../config/samples/product.json"
interface ProductDetailState {  
  selectedProduct: Product | null;
}

const initialState: ProductDetailState = {
  selectedProduct: sample as unknown as Product, // Default product for testing, replace with null in production
};

/**
 * Redux slice for managing the state of the selected product in the product detail view.
 *
 * @remarks
 * This slice provides actions and reducers to set or clear the currently selected product.
 *
 * @example
 * // Set a selected product
 * dispatch(setSelectedProduct(product));
 *
 * // Clear the selected product
 * dispatch(clearSelectedProduct());
 *
 * @see {@link setSelectedProduct}
 * @see {@link clearSelectedProduct}
 */
const productDetailSlice = createSlice({
  name: "productDetail",
  initialState,
  reducers: {
    setSelectedProduct: (state, action: PayloadAction<Product | null>) => {
      state.selectedProduct = action.payload;
    },
    clearSelectedProduct: (state) => {
      state.selectedProduct = null;
    },
  },
});

export const { setSelectedProduct, clearSelectedProduct } = productDetailSlice.actions;
export default productDetailSlice.reducer;
